'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');

var _Modal = require('../../components/Modal/Modal');var _Modal2 = _interopRequireDefault(_Modal);

var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../constants');
var _constructLink = require('../../helpers/constructLink');

var _MobileContacts = require('./MobileContacts.scss');var styles = _interopRequireWildcard(_MobileContacts);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Module
// Components
// Helpers
// Styles
var MobileContacts = function (_Component) {_inherits(MobileContacts, _Component);function MobileContacts() {var _temp, _this, _ret;_classCallCheck(this, MobileContacts);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { phoneIsRevealed: {
        primary: false,
        secondary: false } }, _this.







    renderCompanyName = function (companyName) {return _react2.default.createElement('span', { className: styles.textAlignment }, companyName);}, _this.

    renderCompanyLink = function (content) {var _cx;var
      agencyId = _this.props.realEstateData.agencyId;
      var isCompanyActive = _this.props.isCompanyActive;

      return (
        _react2.default.createElement(_reactRouter.Link, {
            to: isCompanyActive && (0, _constructLink.constructCompanyLink)(_this.props.locale, agencyId),
            className: (0, _classnames2.default)((_cx = {}, _cx[styles.disabledAgencyLink] = !isCompanyActive, _cx), styles.textAlignment) },

          content));


    }, _this.

    renderLogo = function (logoLink) {
      var logo =
      _react2.default.createElement('div', { className: styles.realEstateIcon },
        _react2.default.createElement('img', { src: (0, _modifyImageLink2.default)(logoLink, _constants.imageModifierTypes.LOGO), alt: '' }));



      return _this.renderCompanyLink(logo);
    }, _temp), _possibleConstructorReturn(_this, _ret);}MobileContacts.prototype.componentWillUnmount = function componentWillUnmount() {this.props.onRequestClose();};MobileContacts.prototype.

  renderContactsFields = function renderContactsFields(type) {var _this2 = this;var _props$contacts$type =
    this.props.contacts[type],name = _props$contacts$type.name,phone = _props$contacts$type.phone;var _props$realEstateData =
    this.props.realEstateData,isAgent = _props$realEstateData.isAgent,companyName = _props$realEstateData.companyName,logo = _props$realEstateData.logo;
    var agencyPageExist = !!(0, _get2.default)(this.props, 'contacts.primary.agency_page');

    var handleClick = function handleClick(event) {
      if (!_this2.state.phoneIsRevealed[type]) {
        event.preventDefault();
        _this2.setState(function (prevState) {var _Object$assign;return {
            phoneIsRevealed: Object.assign({},
            prevState.phoneIsRevealed, (_Object$assign = {}, _Object$assign[
            type] = true, _Object$assign)) };});


      }
    };

    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        isAgent && type === 'primary' ?
        _react2.default.createElement('div', { className: styles.realEstateBlock },

          logo && this.renderLogo(logo, agencyPageExist),

          _react2.default.createElement('div', { className: styles.contactBlock },
            !!companyName &&
            _react2.default.createElement('div', { className: styles.contactRow },
              _react2.default.createElement('div', { className: (0, _classnames2.default)('icon icon-office', styles.officeIcon) }),
              this.renderCompanyLink(companyName)),


            name && _react2.default.createElement('div', { className: styles.contactRow },
              _react2.default.createElement('div', { className: (0, _classnames2.default)('icon icon-user', styles.officeIcon) }),
              _react2.default.createElement('span', { className: styles.textAlignment }, name)))) :




        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.contactRow, styles.contactName) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)('icon icon-user', styles.officeIcon) }),
          name),



        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.contactRow, styles[type], styles.buttons) },
          type === 'primary' && this.props.contactButton,
          _react2.default.createElement('a', {
              href: 'tel:' + (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(phone),
              className: (0, _classnames2.default)(styles.phone, this.state.phoneIsRevealed[type] && styles.opened),
              'data-rel': 'external',
              onClick: handleClick },

            _react2.default.createElement('span', { className: styles.iconsIndent },
              _react2.default.createElement('span', { className: 'icon icon-phone' })),

            _react2.default.createElement('span', { className: styles.data },
              this.state.phoneIsRevealed[type] ?
              (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(phone)) :
              this.props.translate('propertyDetails', 'contacts', 'showNumber')))),



        this.state.phoneIsRevealed[type] && _react2.default.createElement('div', { className: styles.contactRow },
          _react2.default.createElement('span', { className: styles.onMapTitle }, this.props.onMapTitle))));



  };MobileContacts.prototype.

  render = function render() {var _props =
    this.props,isOpen = _props.isOpen,onRequestClose = _props.onRequestClose,isRtl = _props.isRtl,children = _props.children;
    return (
      _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onRequestClose: onRequestClose, className: 'mobileContacts', isRtl: isRtl },
        children ||
        _react2.default.createElement('div', { className: styles.contacts },
          this.renderContactsFields('primary'),
          this.props.contacts.secondary && this.renderContactsFields('secondary'))));




  };return MobileContacts;}(_react.Component);exports.default = MobileContacts;


MobileContacts.propTypes = {
  contacts: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool,
  isCompanyActive: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  realEstateData: _propTypes2.default.object,
  onMapTitle: _propTypes2.default.array,
  children: _propTypes2.default.node,
  contactButton: _propTypes2.default.node };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileContacts/MobileContacts.js
// module id = 1206
// module chunks = 0